// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".clickToCallModal-container {\n  width: 500px;\n  display: flex;\n  flex-direction: column;\n}\n\n.clickToCallModal-header {\n  display: flex;\n  justify-content: space-between;\n  padding: 15px;\n  align-items: center;\n}\n\n.clickToCallModal-footer {\n  padding: 35px 15px;\n  display: flex;\n  justify-content: center;\n  flex-grow: 1;\n  align-items: center;\n}\n\na {\n  text-decoration: none;\n}\n", ""]);
// Exports
module.exports = exports;
